import { useEffect, useRef } from 'react';

import {
  FiltersParamConfig,
  FiltersParamType,
  FiltersValueFromType,
  useFiltersStore,
} from '@sbv-clients/shared-state';

export function usePersistedParam<
  T extends FiltersParamType,
  E extends string | number = never
>(
  config: FiltersParamConfig<T, E>
): [
  FiltersValueFromType<T, E>,
  (v: FiltersValueFromType<T, E>) => void,
  {
    reset: () => void;
    initialValue: FiltersValueFromType<T, E>;
  }
] {
  const { pageKey, paramKey } = config;

  useEffect(() => {
    useFiltersStore.getState().registerParam(config);
    // eslint-disable-next-line
  }, []);

  const value = useFiltersStore(
    (state) => state.pageParams[pageKey]?.[paramKey]
  );

  const initialValue = useRef(value).current;

  const setValue = (v: FiltersValueFromType<T, E>) =>
    useFiltersStore.getState().setParam(pageKey, paramKey, v);

  const reset = () => useFiltersStore.getState().resetParam(pageKey, paramKey);

  return [value ?? config.defaultValue, setValue, { reset, initialValue }];
}
